import { createFileRoute, Outlet } from "@tanstack/react-router";
import { SettingsSidebar } from "@/shared/ui/settings-sidebar";

const SettingsLayout = () => {
  return (
    <SettingsSidebar>
      <Outlet />
    </SettingsSidebar>
  );
};

export const Route = createFileRoute("/_authed/$companySlug/_settings")({
  component: SettingsLayout,
});
